import { ActionsTypes } from "../actionTypes";
import { AvailableUsersPayload } from "../types";

export type LoadAvailableUsersAction = ReturnType<typeof loadAvailableUsersRequest>;

export const loadAvailableUsersRequest = (payload: AvailableUsersPayload = {}) => ({
    type: ActionsTypes.LOAD_USERS,
    ...payload,
});

export const reloadAvailableUsersRequest = () => ({
    type: ActionsTypes.LOAD_USERS,
    forceReload: true,
});
